import react from 'react';

const Header = () => (
    <header className="App-header">
        <div className="Title-Container">     {/* TODO: REFACTOR THIS */}
            <h1 className="Ttile"><span id={"Winston"}>Winston</span> John Reichelt</h1>
        </div>
    </header>
)

export default Header;